import { render, staticRenderFns } from "./revenueOrders.vue?vue&type=template&id=52a15de6&scoped=true&"
import script from "./revenueOrders.vue?vue&type=script&lang=js&"
export * from "./revenueOrders.vue?vue&type=script&lang=js&"
import style0 from "./revenueOrders.vue?vue&type=style&index=0&id=52a15de6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a15de6",
  null
  
)

export default component.exports